'use strict';

var config = require('../common/config');

function configBuilder(requestInfo) {
    var parsedParamsInfo = parseParamsInfo(requestInfo.paramsInfo);
    return {
        url: requestInfo.url,
        allowedParams: parsedParamsInfo.allowed,
        requiredBuilderParams: parsedParamsInfo.required,
        builderParams: parsedParamsInfo.builderParams,
        builderParamWithRequestParamsMap: parsedParamsInfo.map,
        builderMethodName: toCamelCase(requestInfo.name),
        requestType: requestInfo.requestType || 'get',
        formDataUsage: requestInfo.hasOwnProperty('formDataUsage') ? requestInfo.formDataUsage : false,
        methodTypeMap: parsedParamsInfo.methodTypeMap,
        useParser: requestInfo.hasOwnProperty('useParser') ? requestInfo.useParser : true
    };
}

function parseResponse(response) {
    return {
        items: response.data.data,
        pagination: {
            totalItemsCount: response.data._meta.totalCount,
            totalPageCount: response.data._meta.pageCount,
            perPage: response.data._meta.perPage,
            current: response.data._meta.currentPage,
            hasNext: response.data._meta.currentPage < response.data._meta.pageCount,
            hasPrev: response.data._meta.currentPage > 1
        }
    };
}
function toCamelCase(str) {
    if (str === 'isDesktop') return 'isDesktop';
    var i = 0;
    var character = '';
    var noCamelCaseStr = str;
    while (i < str.length) {
        character = str.charAt(i);
        if (character == character.toUpperCase() && character != character.toLowerCase()) {
            noCamelCaseStr = str.replace(character, '-' + character.toLowerCase());
        }
        i++;
    }
    var newStr = noCamelCaseStr.toLowerCase().replace(/[-_—](.)/g, function (match, group1) {
        return group1.toUpperCase();
    });
    return newStr.charAt(0).toLowerCase() + newStr.slice(1);
}
function parseParamsInfo(paramsInfoArr) {
    var builderParams = [];
    var builderParamWithRequestParamsMap = {};
    var allowed = [];
    var required = [];
    var methodsDataTypesMap = {};
    paramsInfoArr.forEach(function (oneParamInfo) {
        var nameForBuilder = toCamelCase(oneParamInfo.name);
        builderParams.push(nameForBuilder);
        builderParamWithRequestParamsMap[nameForBuilder] = oneParamInfo.name;
        allowed.push(oneParamInfo.name);
        if (oneParamInfo.required) {
            required.push(nameForBuilder);
        }
        if (oneParamInfo.hasOwnProperty('type') && oneParamInfo.type !== '') {
            methodsDataTypesMap[oneParamInfo.name] = oneParamInfo.type;
        }
    });
    return {
        builderParams: builderParams,
        map: builderParamWithRequestParamsMap,
        allowed: allowed,
        required: required,
        methodTypeMap: methodsDataTypesMap
    };
}

module.exports = {
    configBuilder: configBuilder,
    parseResponse: parseResponse
};